import { TreeDataNode } from "antd";

export const permissionsDataNode: TreeDataNode[] = [
    {
        title: 'Eventos',
        key: 'events:index',
    },
    {
        title: 'Plan de Trabajo',
        key: 'work-plans:index',
        children: [
            {
                title: 'Admin Plan de Trabajo',
                key: 'work-plans:admin',
            },
            {
                title: 'Registrar Actividad',
                key: 'work-plans:create',
            },
            {
                title: 'Actualizar Progreso',
                key: 'work-plans:edit',
            },
            {
                title: 'Subir Evidencia',
                key: 'work-plans:upload-evidence',
            },

        ]
    },
    {
        title: 'Resumen por UO',
        key: 'work-plans-summary:index',
    },
    {
        title: 'Renta de Lugares',
        key: 'rent-places:index',
        children: [
            {
                title: 'Admin Renta de Lugares',
                key: 'rent-places:admin',
            },
            {
                title: 'Gestión Teatro',
                key: 'rent-places:teatro',
            },
            {
                title: 'Gestión Polideportivo',
                key: 'rent-places:polideportivo',
            },
        ]
    },
    {
        title: 'Configuración',
        key: 'management:menu',
        children: [
            {
                title: 'Atiende',
                key: 'attendants:index'
            },
            {
                title: 'Tipos de facturas',
                key: 'invoice-types:index'
            },
            {
                title: 'Tipos de eventos',
                key: 'event-types:index'
            },
            {
                title: 'Usuarios Admin',
                key: 'users-bo:index'
            },
        ]
    },
    {
        title: 'Acciones',
        key: 'actions:menu',
        children: [
            {
                title: 'Crear Eventos',
                key: 'action:create-events'
            },
            {
                title: 'Asignar Facturas',
                key: 'action:assign-invoices'
            },
            {
                title: 'Ver Facturas Asignadas',
                key: 'action:view-assign-invoices'
            },
        ]
    }
];

export const PermissionsConstants = {
    EMPLOYEES_INDEX: 'employees:index',
    EMPLOYEES_GOD: 'employees:god',
    ACTION_CREATE_EVENTS: 'action:create-events',
    ACTION_VIEW_ASSIGN_INVOICE: 'action:view-assign-invoices',
    ACTION_ASSIGN_INVOICE: 'action:assign-invoices',
    WORK_PLAN_INDEX: 'work-plans:index',
    WORK_PLAN_ADMIN: 'work-plans:admin',
    WORK_PLAN_CREATE: 'work-plans:create',
    WORK_PLAN_EDIT: 'work-plans:edit',
    WORK_PLAN_UPLOAD_EVIDENCE: 'work-plans:upload-evidence',
    WORK_PLAN_SUMMARY: 'work-plans-summary:index',
    RENT_PLACE_INDEX: 'rent-places:index',
    RENT_PLACE_ADMIN: 'rent-places:admin',
    RENT_PLACE_TEATRO: 'rent-places:teatro',
    RENT_PLACE_POLIDEPORTIVO: 'rent-places:polideportivo',
}
